import { keyOf, newRequestId } from "./doorGuests";

export const FLAG_TEXT = {
  unreadable: "Unreadable in the screenshot",
  truncated: "Cut off in the screenshot — check it",
  uncertain: "Not sure — please check",
};

export const toRow = (c, shotIndex) => ({
  temp_id: c.temp_id,
  screenshot_index: shotIndex,
  row_index: c.row_index,
  include: true,
  identifier: c.username || "",
  display_name: c.display_name || "",
  first_name: "",
  last_name: "",
  flags: c.flags || {},
});

export const manualRow = () => ({
  temp_id: newRequestId(), screenshot_index: null, row_index: 0, include: true,
  identifier: "", display_name: "", first_name: "", last_name: "", flags: {},
});

export const orderRows = (rows) =>
  [...rows].sort((a, b) => (a.screenshot_index ?? 1e9) - (b.screenshot_index ?? 1e9) || a.row_index - b.row_index);

// Light, non-blocking duplicate hints: earlier screenshot in this batch, or already on the guest list.
export const duplicateHints = (rows, existingKeys) => {
  const firstShot = new Map();
  const hints = {};
  orderRows(rows).forEach((r) => {
    const key = keyOf(r.identifier);
    if (!key) return;
    const earlier = firstShot.get(key);
    hints[r.temp_id] = {
      earlierShot: earlier !== undefined && earlier !== r.screenshot_index ? earlier : null,
      earlierInBatch: earlier !== undefined,
      onList: existingKeys.has(key),
    };
    if (!firstShot.has(key)) firstShot.set(key, r.screenshot_index);
  });
  return hints;
};
